(function ($, ko) {
    var cardsListModel = function (updateHeight, template) {
        this.updateHeight = updateHeight;
        this.template = new $.cdh.services.templateExtractor(template);
        this.cards = ko.observableArray();
        this.dependents = ko.observableArray();

        this.cardsAllowed = ko.observable(!$.cdh.helper.hasPermission($.cdh.enums.userPermission.userPermissionEmployerNoDebitCard));

        this.cardsRequest = new $.cdh.get.cards.list(function (data) {
            this.pager.currentPageIndex(data.PageNo);
            this.pager.lastPageIndex(data.TotalPages);

            var cards = $.map(data.Cards, function (card) {
                if (card.CardImage) {
                    card.CardImageUrl = "data:image/png;base64," + card.CardImage;
                } else {
                    card.CardImageUrl = null;
                }
            return new $.cdh.models.CardsDetails(card,  data.ReissueText, this.allowIssueNew, this.template, this.onUpdateCallback);
            }.bind(this));
            this.cards(cards);
            recalcWidgetsHeights();            
            cards.filter(card => ko.isObservable(card.IsOpened)).forEach(card => card.IsOpened.subscribe(updateHeight));
        }.bind(this));
        
        this.dependentsCardsRequest = new $.cdh.get.cards.dependents(function (data) {
            var dependents = $.map(data.Dependents, function (dependent) {
                return new $.cdh.models.CardDependent(dependent, this.updateHeight, this.onUpdateCallback);
            }.bind(this));
            recalcWidgetsHeights();
            this.dependents(dependents);
        }.bind(this));

        this.load = function () {
            if (this.cardsAllowed()) {
                this.cardsRequest.load().done(function () {
                    recalcWidgetsHeights();
                    this.dependentsCardsRequest.load();
                }.bind(this));
            }
        }.bind(this);

        this.refreshCards = function () {
            if (this.cardsAllowed()) {
            this.cardsRequest.load({pageNo: this.pager.currentPageIndex(), pageSize: 10});
            }
        }.bind(this);

        this.onUpdateCallback = function () {
            this.load();
        }.bind(this);

        this.issueNewRequest = new $.cdh.post.cards.new();

        this.hasNew = function () {
            return $.grep(this.cards(), function (card) {
                return card.CardStatus() == $.cdh.enums.cardStatus.new;
            }).length > 0;
        };
        this.allowIssueNew = $.cdh.helper.hasPermission($.cdh.enums.userPermission.userPermissionRequestNewCard);
        this.issueNewVisible = ko.computed(function () {
            return this.allowIssueNew && !this.hasNew() && this.cardsAllowed();
        }.bind(this));

        this.issueCard = function () {
            //Check cards with status New
            var hasNew = this.hasNew();
            if (hasNew) {
                $.cdh.helper.alert("Cannot create a new card. Participant already has a NEW card");
                return;
            }
            if (this.issueNewRequest.isLoading())
                return;
            this.issueNewRequest.load({ id: '' }).done(function (result) {
                //var model = new $.cdh.models.CardsDetails(result, this.allowIssueNew);
                //this.cards.push(model);
                this.load();

                $.cdh.helper.alert($.cdh.languageConstant.getConstant("cards.card-issued_successfully"));
            }.bind(this));
        }.bind(this);

        this.isEmpty = ko.computed(function () {
            return !this.cardsRequest.isLoading() && this.cards().length === 0;
        }, this);

        this.cardsRequest.state.subscribe(updateHeight);
        
        this.openedCount = ko.pureComputed(function () {
            return this.cards().filter(c => c.IsOpened && c.IsOpened()).length;
        }, this);

        this.openedCount.subscribe(function () {
            updateHeight();
        });


        var cardsPagerModel = function () {

            this.currentPageIndex = ko.observable(1);
            this.lastPageIndex = ko.observable(1);

            this.nextPage = function () {
                if (this.lastPageIndex() > this.currentPageIndex()) {
                    this.currentPageIndex(this.currentPageIndex() + 1);

                    if (this.pageChanged != null)
                        this.pageChanged();
                }
            };

            this.prevPage = function () {
                if (this.currentPageIndex() > 1) {
                    this.currentPageIndex(this.currentPageIndex() - 1);

                    if (this.pageChanged != null)
                        this.pageChanged();
                }
            };

            this.pageChanged = null;

       this.noop = function() {};
        };

        this.pager = new cardsPagerModel();
        this.pager.pageChanged = function () {
            this.refreshCards();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }.bind(this);

        this.load();
    };

    ko.components.register('cards-list', {
        template: { element: 'template-cards-list' },
        viewModel: {
            createViewModel: function (params, componentInfo) {
                var updateHeight = updateContainerHeight(componentInfo.element);
                return new cardsListModel(updateHeight, params.template);
            }
        }
    });
    ko.bindingHandlers.cardNumberContrast = {
        init: function (element) {
            var img = element.querySelector('.card_image');
            var number = element.querySelector('.card-number-overlay');
            var fullname = element.querySelector('.card-fullname-overlay');
            var status = element.querySelector('.card-status-overlay');
            if (!img || !number || !fullname || !status) return;

            function setContrast() {
                if (!img.complete || img.naturalWidth === 0) return;
                var canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                var imageData = ctx.getImageData(0, canvas.height - 40, 80, 40).data;
                var r = 0, g = 0, b = 0, count = 0;
                for (var i = 0; i < imageData.length; i += 4) {
                    r += imageData[i];
                    g += imageData[i + 1];
                    b += imageData[i + 2];
                    count++;
                }
                var avg = (r + g + b) / (3 * count);
                var color = avg > 160 ? '#000' : '#fff';
                number.style.color = color;
                fullname.style.color = color;
                status.style.color = color;
            }
            img.addEventListener('load', setContrast);
            if (img.complete) setContrast();
        }
    };
})(jQuery, ko);